<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../helpers/validators_files";

export default {
  components: {},
  props: {},
  data() {
    return {
      attachment_qssam: "",
      attachment_passport: "",
      attachment_national: "",
      attachment_address: "",
      attachment_vaccine_card: "",
      attachment_wounded: "",
    };
  },
  validations: {
    attachment_qssam: {
      required: requiredIf(function () {
        return this.getMartyrCategory();
      }),
      fileType: fileType(["image/jpg", "image/jpeg", "image/png", "application/pdf"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_passport: {
      required,
      fileType: fileType(["image/jpg", "image/jpeg", "image/png", "application/pdf"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_national: {
      required,
      fileType: fileType(["image/jpg", "image/jpeg", "image/png", "application/pdf"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_address: {
      required,
      fileType: fileType(["image/jpg", "image/jpeg", "image/png", "application/pdf"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_vaccine_card: {
      fileType: fileType(["image/jpg", "image/jpeg", "image/png", "application/pdf"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_wounded: {
      required: requiredIf(function () {
        return this.getWoundedCategory();
      }),
      fileType: fileType(["image/jpg", "image/jpeg", "image/png", "application/pdf"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    form: [
      "attachment_qssam",
      "attachment_passport",
      "attachment_national",
      "attachment_address",
      "attachment_vaccine_card",
      "attachment_wounded",
    ],
  },

  methods: {
    getMartyrCategory() {
      return this.$parent.$parent.$parent.$refs["sacrificer_info"]["category_id"] == "1";
    },
    getWoundedCategory() {
      return this.$parent.$parent.$parent.$refs["sacrificer_info"]["category_id"] == "2";
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    chnageFile(e) {
      this[e.target.id] = e.target.files.length > 0 ? e.target.files[0] : null;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">اضافة المرفقات</h5></div>
      <div class="col-md-12">
        <div class="">
          <h5 class="mb-4">يجب قراءة التعليمات الخاصة برفع المرفقات</h5>

          <ul v-if="getMartyrCategory()" class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق القسام الشرعي</h5>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع القسام الشرعي بصيغة ( jpg , jpeg , png , pdf ) وبحجم لا
                      يتجاوز ( 5mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            v-if="getMartyrCategory()"
            class="col-md-12 mb-3"
            label=" مرفق القسام الشرعي :"
            label-for="attachment_qssam"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_qssam"
                class=""
                placeholder="اختر المرفق"
                accept="*.jpg, *.jpeg, *.png, *.pdf"
                v-model="attachment_qssam"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_qssam.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_qssam.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_qssam.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_qssam.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5mb</span
                >
                <span v-if="!$v.attachment_qssam.fileType"
                  >يجب ان يكون نوع الملف jpg , jpeg , png , pdf</span
                >
              </div>
            </div>
          </b-form-group>
          <ul v-if="getWoundedCategory()" class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق قرار اللجنة الطبية لنسبة العجز</h5>
                    <p class="text-muted">
                      قرار اللجنة الطبية الذي يحوي على نسبة العجز للجريح
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع قرار اللجنة الطبية بصيغة ( jpg , jpeg , png , pdf ) وبحجم لا
                      يتجاوز ( 5mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            v-if="getWoundedCategory()"
            class="col-md-12 mb-3"
            label="مرفق قرار اللجنة الطبية لنسبة العجز :"
            label-for="attachment_wounded"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_wounded"
                class=""
                placeholder="اختر المرفق"
                accept="*.jpg, *.jpeg, *.png, *.pdf"
                v-model="attachment_wounded"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_wounded.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_wounded.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_wounded.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_wounded.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5mb</span
                >
                <span v-if="!$v.attachment_wounded.fileType"
                  >يجب ان يكون نوع الملف jpg , jpeg , png , pdf</span
                >
              </div>
            </div>
          </b-form-group>
          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق جواز سفر الحاج</h5>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع مرفق جواز سفر الحاج بصيغة ( jpg , jpeg , png , pdf ) وبحجم
                      لا يتجاوز ( 5mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق جواز سفر الحاج :"
            label-for="attachment_passport"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_passport"
                class=""
                placeholder="اختر المرفق"
                accept="*.jpg, *.jpeg, *.png, *.pdf"
                v-model="attachment_passport"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_passport.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_passport.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_passport.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_passport.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5mb</span
                >
                <span v-if="!$v.attachment_passport.fileType"
                  >يجب ان يكون نوع الملف jpg , jpeg , png , pdf</span
                >
              </div>
            </div>
          </b-form-group>
          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      مرفق البطاقة الوطنية او هوية الاحوال المدنية
                    </h5>
                    <p class="text-muted">
                      رفع البطاقة الوطنية او هوية الاحوال المدنية من الجانبين الامامي
                      والخلفي .
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع المرفق بصيغة ( jpg , jpeg, png , pdf ) وبحجم لا يتجاوز ( 5mb
                      ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق البطاقة الوطنية او هوية الاحوال المدنية :"
            label-for="attachment_national"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_national"
                class=""
                placeholder="اختر المرفق"
                accept="*.jpg, *.jpeg, *.png, *.pdf"
                v-model="attachment_national"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_national.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_national.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_national.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_national.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5mb</span
                >
                <span v-if="!$v.attachment_national.fileType"
                  >يجب ان يكون نوع الملف jpg , jpeg , png , pdf</span
                >
              </div>
            </div>
          </b-form-group>
          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق بطاقة السكن</h5>
                    <p class="text-muted">
                      رفع بطاقة السكن من الجانبين الامامي والخلفي .
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع مرفق بطاقة السكن بصيغة ( jpg , jpeg , png , pdf ) وبحجم لا
                      يتجاوز ( 5mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق بطاقة السكن :"
            label-for="attachment_address"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_address"
                class=""
                placeholder="اختر المرفق"
                accept="*.jpg, *.jpeg, *.png, *.pdf"
                v-model="attachment_address"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_address.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_address.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_address.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_address.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5mb</span
                >
                <span v-if="!$v.attachment_address.fileType"
                  >يجب ان يكون نوع الملف jpg , jpeg , png , pdf</span
                >
              </div>
            </div>
          </b-form-group>
          <ul class="verti-timeline list-unstyled mb-2">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-left-arrow-circle font-color-red"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">مرفق بطاقة اللقاح الدولية</h5>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bxs-file font-color-blue"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5 class="font-size-14">
                      يجب رفع مرفق بطاقة اللقاح الدولية بصيغة ( jpg , jpeg , png , pdf )
                      وبحجم لا يتجاوز ( 5mb ) .
                    </h5>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق بطاقة اللقاح الدولية :"
            label-for="attachment_vaccine_card"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_vaccine_card"
                class=""
                placeholder="اختر المرفق"
                accept="*.jpg, *.jpeg, *.png, *.pdf"
                v-model="attachment_vaccine_card"
                @change="chnageFile"
                :class="{ 'is-invalid': $v.attachment_vaccine_card.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_vaccine_card.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_vaccine_card.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5mb</span
                >
                <span v-if="!$v.attachment_vaccine_card.fileType"
                  >يجب ان يكون نوع الملف jpg , jpeg , png , pdf</span
                >
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>

  <!-- end page title -->
</template>
